<template>
  <div class="animated fadeIn">
    <template v-if="detail.length > 0">
      <table class="table table-bordered" >
        <thead>
        <tr>
          <th>No</th>
          <th>Customer</th>
          <th>Down Time</th>
          <th>Duration</th>
          <th>Description</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(detailMetric, i) in detail">
          <template v-if="detailMetric.data.length > 0">
            <tr>
              <td :rowspan="detailMetric.data.length ">{{i+1}}</td>
              <td :rowspan="detailMetric.data.length ">{{detailMetric.cust_acc_name}}</td>
              <td>{{detailMetric.data[0].down_time}}</td>
              <td>{{detailMetric.data[0].duration | convertSecond}}</td>
              <td>
                {{detailMetric.data[0].problem}} <br>
                {{detailMetric.data[0].cause}}
              </td>
            </tr>
            <template v-if="detailMetric.data.length > 1">
              <template v-for="(detailInCustomer, indeks) in detailMetric.data">
                <template v-if="indeks > 0">
                  <tr>
                    <td>{{detailInCustomer.down_time}}</td>
                    <td>{{detailInCustomer.duration | convertSecond}}</td>
                    <td>
                      {{detailInCustomer.problem}} <br>
                      {{detailInCustomer.cause}}
                    </td>
                  </tr>
                </template>

              </template>

            </template>
          </template>
        </template>
        <tr v-if="totalDown > 0">
          <td colspan="5">
            <strong>Total Down  :</strong>
            {{totalDown}}</td>
        </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div class="alert alert-warning">
        No Data Down Time Metric Fttx
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detail: []
      }
    },
    watch: {
      dataDetailMetric () {
        this.detail = this.dataDetailMetric
      }
    },
    created () {
      // console.log(this.dataDetailMetric)
      this.detail = this.dataDetailMetric
      // console.log('length', this.dataDetailMetric.length)
    },
    props:{
      dataDetailMetric: {
        type: Array,
        default: () => []
      },
      totalDown: {
        type: Number
      }
    }
  }
</script>
